import React, { useRef, useState, useEffect } from 'react';
import Popper from '@mui/material/Popper';
import Box from '@mui/material/Box';
import { ClickAwayListener } from '@mui/material';
import { useWindowSize } from '../../../utils/hooks';
import { responsiveSizeTimesheet } from '../../../utils/constants';
import BaseSwipeableDrawer from '../BaseSwipeableDrawer/BaseSwipeableDrawer';
import colors from '../../../scss/colors';
import classes from './ThreeDotMenu.module.scss';

export default function ThreeDotMenu({
  menuComponent,
  children,
  onOpen = () => {},
  onClose = () => {},
  imperativeState = false,
  autoTrigger = false,
  verticalScroll
}) {
  const size = useWindowSize();
  const ref = useRef(null);
  const [open, setOpen] = useState(false);

  const handleClickAway = () => {
    setOpen(false);
    onClose();
  };

  useEffect(() => {
    if (!imperativeState) {
      setOpen(false);
    }
  }, [imperativeState]);

  return (
    <>
      <div
        ref={ref}
        role="presentation"
        className={`${classes.mainInput}`}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((prev) => !prev);
          onOpen();
        }}
      >
        {menuComponent}
      </div>
      {(open || autoTrigger) && size.width <= responsiveSizeTimesheet && (
        <BaseSwipeableDrawer
          verticalScroll={verticalScroll}
          open={open || autoTrigger}
          closeHandler={() => setOpen(false)}
        >
          <div className={classes.swiper} />
          {children}
        </BaseSwipeableDrawer>
      )}
      {open && size.width > responsiveSizeTimesheet && (
        <ClickAwayListener onClickAway={() => handleClickAway()}>
          <Popper open anchorEl={ref.current}>
            <Box
              sx={{
                padding: '30px 34px',
                backgroundColor: colors.PAGE_BACKGROUND,
                boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                borderRadius: '20px'
              }}
              onClick={(e) => {
                e.stopPropagation();
                setOpen(false);
              }}
            >
              {children}
            </Box>
          </Popper>
        </ClickAwayListener>
      )}
    </>
  );
}
